function IconBadge({ config, size = 44, className = "" }) {
  const { icon, tint } = config;
  const badgeStyle = {
    width: size,
    height: size,
    borderRadius: "0.75rem",
    backgroundColor: tint.bg,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  };

  return (
    <div style={badgeStyle} className={className}>
      <img
        src={icon}
        alt=""
        width={size * 0.9}
        height={size * 0.9}
        style={{ objectFit: "contain" }}
      />
    </div>
  );
}
export default IconBadge